export default __webpack_public_path__ + "static/location-head-map-9fe9b376987711e4ac5ebfc230be7550.png";